<template>
  <div>
    <GenericPage class="mb--50">
      <template slot="breadcrumb-items">
        <li class="active bold">Cookies.</li>
      </template>
      <template slot="title">
        Política de Cookies en la Red.
      </template>
      <template slot="body">
        <PoliticaCookies />
      </template>
    </GenericPage>
    <LightBanner />
  </div>
</template>

<script>
import MPHeader from "@components/main-page/MPHeader";
import PoliticaCookies from "@components/cookies/PoliticaCookies";
import LightBanner from "@components/cookies/LightBannerCookie";
import GenericPage from "./new-portal-views/GenericPage.vue";

export default {
  name: "PoliticaCookiesPage",
  components: {
    PoliticaCookies,
    MPHeader,
    LightBanner,
    GenericPage
  }
}
</script>

<style scoped>

</style>